<template>
  <div class="change_cover">
    change_cover
  </div>
</template>

<script>
export default {
  name: 'ChangeCover',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
